import React, { useState, useEffect } from 'react';
import { FaTimes } from 'react-icons/fa';

const API_URL = '/api';

const initialFields = { Code:'', DueDate:'', Description:'' };

const DeliveryTermsFormModal = ({ open, onClose, onSubmit, initialData, isEdit }) => {
  const [fields,setFields] = useState(initialFields);
  const [errors,setErrors] = useState({});

  useEffect(()=>{
    if(open){
      setFields(isEdit && initialData ? {...initialData} : initialFields);
      setErrors({});
    }
  },[open,initialData,isEdit]);

  const handleChange=(e)=>setFields({...fields,[e.target.name]:e.target.value});

  const validate=()=>{
    const errs={};
    if(!fields.Code) errs.Code="Required";
    if(!fields.Description) errs.Description="Required";
    setErrors(errs);
    return Object.keys(errs).length===0;
  };

  const handleSubmit=async(e)=>{
    e.preventDefault();
    if(!validate()) return;
    try{
      const method=isEdit?"PUT":"POST";
      const url=isEdit?`${API_URL}/Delivery-terms/${fields.Code}`:`${API_URL}/Delivery-terms`;
      const res=await fetch(url,{
        method,
        headers:{'Content-Type':'application/json'},
        body:JSON.stringify(fields)
      });
      if(!res.ok) throw new Error("Save failed");
      onSubmit();
    }catch(err){ alert(err.message); }
  };

  if(!open) return null;

  return (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40 px-2">
    <div className="bg-[#E5E1DA] rounded-2xl shadow-2xl w-full max-w-lg p-4 sm:p-8 relative max-h-[90vh] overflow-y-auto">
      
      {/* Close Button */}
      <button 
        className="absolute top-3 right-3 text-[#2b6777] hover:text-[#52ab98]"
        onClick={onClose}
      >
        <FaTimes size={18} />
      </button>

      {/* Title */}
      <h2 className="text-lg sm:text-2xl font-bold text-[#2b6777] mb-4 sm:mb-6 text-center sm:text-left">
        {isEdit ? 'Edit' : 'Create'} Delivery Term
      </h2>

      {/* Form */}
      <form onSubmit={handleSubmit} className="space-y-4">
        {['Code','DueDate','Description'].map(field => (
          <div key={field}>
            <label className="block text-[#2b6777] font-medium text-sm sm:text-base">
              {field}
            </label>
            <input
              name={field}
              value={fields[field]}
              onChange={handleChange}
              className={`w-full border rounded px-2 sm:px-3 py-2 text-sm sm:text-base ${
                errors[field] ? 'border-red-400' : 'border-[#c8d8e4]'
              }`}
            />
            {errors[field] && (
              <span className="text-xs text-red-500">{errors[field]}</span>
            )}
          </div>
        ))}

        {/* Actions */}
        <div className="flex flex-col sm:flex-row justify-end gap-3 sm:gap-4 mt-4 sm:mt-6">
          <button
            type="button"
            onClick={onClose}
            className="px-3 sm:px-4 py-2 rounded bg-gray-200 text-[#2b6777] text-sm sm:text-base"
          >
            Cancel
          </button>
          <button
            type="submit"
            className="px-4 sm:px-6 py-2 rounded bg-[#52ab98] text-white text-sm sm:text-base"
          >
            {isEdit ? 'Update' : 'Create'}
          </button>
        </div>
      </form>
    </div>
  </div>
);

};

export default DeliveryTermsFormModal;
